import { createCounterMachine } from '@sg/machines';

/**
 * A small state machine with async storage support for managing placed orders counter.
 */
export const placedOrdersCounterMachine = createCounterMachine('placed-orders-counter');
